module.exports = __webpack_public_path__ + "static/media/24UHCHR7.5ac5bca7.jpg";